/**
 * Demo cash register sessions (caisses) — one OUVERTE for the active CAISSIER,
 * four CLOTUREE within the last 7 days with mixed écart (0 / + / -), and one
 * older closed session beyond a month. CA libre / CHIFA / nb_ventes are
 * computed from the ventes arg scoped by caisse_id.
 */
import { nowIso, hoursAgoIso } from "../uuid.js";

function pickCaissier(users) {
  const active = users.find((u) => u.id.includes("caissier-1")) || users[0];
  const other = users.find((u) => u.id.includes("caissier-2")) || active;
  return { active, other };
}

function scopeVentes(ventes, caisseId) {
  const rows = (ventes || []).filter((v) => v && v.caisse_id === caisseId);
  let caLibre = 0;
  let caChifa = 0;
  for (const v of rows) {
    const total = Number(v.montant_total ?? v.total ?? 0) || 0;
    if (v.type_vente === "CHIFA") caChifa += total;
    else caLibre += total;
  }
  return { ca_libre: caLibre, ca_chifa: caChifa, nb_ventes: rows.length };
}

function mkCaisse(opts) {
  const { id, numero, caissier, statut, openedH, closedH, fondsCloture, ecart, notes, ventes } = opts;
  const date_ouverture = hoursAgoIso(openedH);
  const date_cloture = closedH == null ? null : hoursAgoIso(closedH);
  const stats = scopeVentes(ventes, id);
  const ca_total = stats.ca_libre + stats.ca_chifa;
  return {
    id,
    numero,
    caissier_id: caissier.id,
    caissier: { id: caissier.id, nom: caissier.nom, prenom: caissier.prenom },
    statut,
    date_ouverture,
    date_cloture,
    fonds_ouverture: 10000,
    fonds_cloture: fondsCloture,
    ca_libre: stats.ca_libre,
    ca_chifa: stats.ca_chifa,
    ca_total,
    nb_ventes: stats.nb_ventes,
    ecart,
    notes,
    created_at: date_ouverture,
    updated_at: date_cloture || nowIso(),
  };
}

export function buildCaisses(users, ventes) {
  const { active, other } = pickCaissier(users);

  return [
    mkCaisse({
      id: "caisse-001", numero: "CAISSE-2026-00012", caissier: active, statut: "OUVERTE",
      openedH: 6, closedH: null, fondsCloture: 0, ecart: 0,
      notes: "Session du matin — poste principal", ventes,
    }),
    mkCaisse({
      id: "caisse-002", numero: "CAISSE-2026-00011", caissier: other, statut: "CLOTUREE",
      openedH: 32, closedH: 24, fondsCloture: 48750, ecart: 0,
      notes: "Clôture conforme, aucun écart", ventes,
    }),
    mkCaisse({
      id: "caisse-003", numero: "CAISSE-2026-00010", caissier: active, statut: "CLOTUREE",
      openedH: 56, closedH: 48, fondsCloture: 62300, ecart: 250,
      notes: "Léger surplus — pourboire client", ventes,
    }),
    mkCaisse({
      id: "caisse-004", numero: "CAISSE-2026-00009", caissier: other, statut: "CLOTUREE",
      openedH: 80, closedH: 72, fondsCloture: 41200, ecart: -500,
      notes: "Manquant 500 DZD — rendu monnaie erroné (à vérifier)", ventes,
    }),
    mkCaisse({
      id: "caisse-005", numero: "CAISSE-2026-00008", caissier: active, statut: "CLOTUREE",
      openedH: 128, closedH: 120, fondsCloture: 55600, ecart: 0,
      notes: "RAS", ventes,
    }),
    mkCaisse({
      id: "caisse-006", numero: "CAISSE-2025-00342", caissier: other, statut: "CLOTUREE",
      openedH: 24 * 38, closedH: 24 * 38 - 8, fondsCloture: 37800, ecart: -150,
      notes: "Archive — clôture mois précédent", ventes,
    }),
  ];
}
